import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

export const redirectToWritableLogin = (timeout = 3000) => {
  const { writableStartUrl } = getIdentifiedPlatformConfig();

  setTimeout(() => {
    if (writableStartUrl) {
      window.location.href = writableStartUrl;
    } else {
      window.location.href = `${window.location.origin}/ui/login`;
    }
  }, [timeout]);
};

export default redirectToWritableLogin;
